import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Share2 } from 'lucide-react';
import { usePdfMode } from './pdf/PdfModeContext';

interface FacebookReactionsProps {
  platform: string;
  dataMetrics: any
}



export function FacebookReactions({ platform, dataMetrics }: FacebookReactionsProps) {
  const pdfMode = usePdfMode();
 const reactionsData = [
    { type: 'Like',  num: dataMetrics?.total_like  ?? 0, color: '#93c5fd' },
    { type: 'Love',  num: dataMetrics?.total_love  ?? 0, color: '#fda4af' },
    { type: 'Care',  num: dataMetrics?.total_care  ?? 0, color: '#fde68a' },
    { type: 'Haha',  num: dataMetrics?.total_haha  ?? 0, color: '#fdba74' },
    { type: 'Wow',   num: dataMetrics?.total_wow   ?? 0, color: '#c084fc' },
    { type: 'Sad',   num: dataMetrics?.total_sad   ?? 0, color: '#a7f3d0' },
    { type: 'Angry', num: dataMetrics?.total_angry ?? 0, color: '#fca5a5' }
  ];

const totalReactions = reactionsData.reduce((sum, item) => sum + item.num, 0);
const shares = 1847;

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0];
    const percentage = ((data.value / totalReactions) * 100).toFixed(1);
    const color = data.payload.color; 
    return (
      <div className="bg-white px-3 py-2 rounded-lg shadow-lg border border-slate-200">
        <span className='d-flex align-items-center'>
          <span className='me-2 ' style={{width:'12px', height:'12px', display:'flex', backgroundColor:color}}></span>
          <p className="text-slate-900" style={{fontSize:'14px'}}>{data.name}</p>
        </span>
        <p className="text-sm text-slate-600" style={{fontSize:'12px'}}>{data.value} reactions</p>
        <p className="text-sm text-slate-600" style={{fontSize:'12px'}}>{percentage}%</p>
      </div>
    );
  }
  return null;
};
  return (
    <Card>
      <CardHeader>
        <CardTitle>Facebook Reactions Breakdown</CardTitle>
        <CardDescription>Distribution of reaction types</CardDescription>
      </CardHeader>
      <CardContent>
      {reactionsData.length === 0 ? (
        <div className="text-sm text-slate-500">No reaction data available for the selected range.</div>
      ) : ( 
        <div className=" gap-2 justify-content-between">
          <>
          {/* Pie Chart */}
          <div className='flex gap-2'>
              <ResponsiveContainer width="65%" height={200}>
                <PieChart>
                  <Pie
                    isAnimationActive={!pdfMode}
                    data={reactionsData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="num"
                    nameKey="type"
                  >
                    {reactionsData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                </PieChart>
              </ResponsiveContainer>
            
            <div className="p-2 px-3 rounded-lg bg-blue-50 border border-blue-200 align-self-center">
              <div className="flex items-center justify-between gap-2 flex-col">
                <p className="text-sm text-center text-slate-600">Total Reactions</p>
                <p className="text-slate-900">{totalReactions.toLocaleString()}</p>
              </div>
            </div>
          </div>

          {/* Breakdown List */}
          
          </>
          <div className="space-y-4">
            <div className=''>
              <p className="text-sm text-slate-600 mb-3 mt-3" style={{fontSize:'14px'}}>Reaction Breakdown</p>
              <div className="gap-4 flex flex-col items-end ">
                {reactionsData.map((reaction, index) => {
                  const percentage = ((reaction.num / totalReactions) * 100).toFixed(2);
                  return (
                    <div key={index} className="flex flex-wrap justify-between w-100" >
                      <div className="flex items-center justify-en space-x-2 w-100"  >
                        <div 
                          className="w-3 h-3 rounded-full" 
                          style={{ backgroundColor: reaction.color }}
                        />
                        <span className="text-sm text-slate-700 me-auto">{reaction.type}</span>
                        <span className='flex ml-auto'>
                        <span className="text-slate-900 text-right" style={{fontSize:'13px'}}>{reaction.num}</span>
                        <span className="text-sm text-slate-500 min-w-[45px] text-right ml-auto" style={{fontSize:'12px'}}>{percentage}%</span>
                        </span>
                      </div>
                      
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Total Reactions */}
            
          </div>
        </div>
      )}
      </CardContent>
    </Card>
  );
}
